module.exports = __webpack_public_path__ + "static/media/dj_set_1.a62148ed.jpg";